/* Stores a logo file on Shopify's CDN through a temporary cart line, then removes the line and posts the contact form with the file URL. */
(function(){
  function up(file,variant){
    var fd=new FormData();fd.append('id',variant);fd.append('quantity','1');fd.append('properties[Logo]',file);fd.append('properties[_rsq_upload]',String(Date.now()));
    return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(j){
      var url=(j&&j.properties&&j.properties.Logo)||'';
      if(!j||!j.key)return url;
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:j.key,quantity:0})}).then(function(){return url},function(){return url});
    }).catch(function(){return ''});
  }
  window.rsUploadLogo=up;
  document.querySelectorAll('form[data-rs-logo-form]').forEach(function(f){
    var busy=false;
    f.addEventListener('submit',function(e){
      var fi=f.querySelector('[data-rs-logo]'),h=f.querySelector('[data-rs-logo-url]'),file=fi&&fi.files&&fi.files[0];
      if(!file||busy)return; /* no file: normal submit */
      e.preventDefault();busy=true;var b=f.querySelector('button[type=submit]');if(b){b.disabled=true;b.textContent='Sending…'}
      up(file,f.getAttribute('data-variant')).then(function(url){if(h)h.value=url||('Upload failed ('+file.name+'): please ask the customer to text or email it');HTMLFormElement.prototype.submit.call(f)});
    });
  });
})();
